// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import global from './global/global'
import Axios from 'axios'
import 'babel-polyfill'

Vue.config.productionTip = false
Vue.prototype.GLOBAL = global  //全局变量
Vue.prototype.$axios = Axios
// Axios.defaults.baseURL = '/http'
Axios.defaults.baseURL = global.http
// import '!style-loader!css-loader!less-loader!./assets/css/base.less'

import './assets/css/base.css'

router.beforeEach((to,from,next)=>{
  window.scrollTo(0,0);
  next();
})
//过滤器
Vue.filter("unscape",function (html) {
  return html
    .replace(html ? /&(?!#?\w+;)/g : /&/g, '&amp;')
    .replace(/&lt;/g, "<")
    .replace(/&gt;/g, ">")
    .replace(/&quot;/g,"\"")
    .replace(/&#34;/g,"\"")
    .replace(/&#39;/g, "\'")
    .replace(/&#160;/g, " ")
    .replace(/&amp;nbsp;/g, "      ");
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js